<template>
  <listing-layout>
    <h1 slot="heading" class="sr-only">Register Horses</h1>
    <div slot="content">
      <h2 slot="heading" class="mb-4">Select Horses To Register</h2>
      <div class="alert alert-warning" v-if="error">{{error}}</div>
      <data-table :dataRows="rows" :dataColumns="columns" :options="options">
        <tableSelectRowTemplate slot-scope="{ row }" slot="expandedSelect" :row="row" :options="{ requireFinancial: true }" class="z-1 p-3" />
        <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.name" :row="row" :options="{ expandMobile: true , showRegistered: true, inline: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li class="d-flex">
              <strong style="padding-right: 2px;">Owner: </strong>
              <tableTextTemplate :text="row.owner_name" :row="row" :options="{ showFinancial: true, inline: true  }" />
            </li>
            <li>
              <strong>Age: </strong>
              <tableTextTemplate :text="String(row.age)" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Sex: </strong>
              <tableTextTemplate :text="row.gender" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Status: </strong>
              <tableTextTemplate :text="row.horse_status ? row.horse_status.name : ''" :row="row" :options="{ inline: true }" />
            </li>
          </ul>
        </div>
      </data-table>
      <div class="sticky-bottom alert bg-primary text-white d-flex flex-wrap align-items-center mb-0" role="alert" v-if="$store.getters.selectedRows.length > 0">
        <div class="flex-grow-1 pr-3 text-center text-lg-left">
          <strong>You have selected: </strong>
          <span v-for="(row, i) in $store.getters.selectedRows" :key="i">
            {{ row.hasOwnProperty('first_name') ? (row.first_name + ' ' + row.last_name) : row.name + (i == $store.getters.selectedRows.length -1 ? '' : ',') }}
          </span>
        </div>
        <router-link v-if="options.registerHorseText && $store.getters.selectedRows.length > 0" class="btn btn-outline-white btn-block-mob mt-2 mt-lg-0 text-nowrap" tag="button" :to="{ name: 'Confirm Horse' }">
          Register Horses
        </router-link>
        <button v-if="options.joinButtonText || options.registerHorseText" class="btn btn-outline-white ml-lg-2 btn-block-mob" @click.prevent="deselectAll">Cancel</button>
      </div>
    </div>
  </listing-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import axios from 'axios'
import listingLayout from '@/components/ListingLayout'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'
import tableSelectRowTemplate from '@/components/DataTableFields/SelectRow'
import eventBus from '@/store/EventBus.js'

export default {
  name: 'HorseRegister',
  components: {
    'listing-layout': listingLayout,
    'data-table': dataTable,
    tableTextTemplate,
    tableSelectRowTemplate
  },
  data() {
    return {
      error: '',
      rows: [],
      columns: [
        {
          label: '',
          field: '',
          headerClass: 'column-lg-small d-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableSelectRowTemplate },
            template: `<tableSelectRowTemplate :row="row" :options="{ requireFinancial: true }" />`
          })
        },
        {
          label: 'Horse Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.name" :row="row" :options="{ showRegistered: true }" />`
          }),
          representedAs(row) { return `${row.name}` }
        },
        {
          label: 'Owner',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.owner_name" :row="row" :options="{ showFinancial: true }" />`
          }),
          representedAs(row) { return `${row.owner}` }
        },
        {
          label: 'Age',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="String(row.age)" :row="row" />`
          }),
          representedAs(row) { return `${row.age}` }
        },
        {
          label: 'Sex',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.gender" :row="row" />`
          }),
          representedAs(row) { return `${row.gender}` }
        },
        {
          label: 'Status',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.horse_status ? row.horse_status.name : ''" :row="row" />`
          }),
          representedAs(row) { return `${row.status ? row.status.name : ''}` }
        }
      ],
      options: {
        selectRows: true,
        registerHorseText: true,
        loaded: false,
        search: true
      }
    }
  },
  mounted() {
    this.$store.commit('deselectAllRows')
    eventBus.$on('financial-error', (message) => { this.error = message })
    axios.get(`${this.$api}/horse/unregistered-horses`).then((response) => {
      if (response.data.status === 'success') {
        this.options.loaded = true
        // Done
        if (response.data.data.length === 0) {
          this.status = 'You have no horses in your list. Press add to add your first horse.'
        }
        this.error = ''
        this.rows = response.data.data
      }
    }).catch((error) => {
      this.options.loaded = true
      // eslint-disable-next-line
      console.log(error)
    })
  },
  beforeDestroy() {
    eventBus.$off('financial-error')
  },
  methods: {
    deselectAll() {
      eventBus.$emit('deselect-all')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Horses/Register/HorseRegister.vue